let host = null;

export function registerConfirmHost(fn) {
  host = fn;
  return () => { if (host === fn) host = null; };
}

// confirmDelete({ title, description, confirmLabel, onConfirm, onCancel }) — nothing runs unless the user clicks the red button.
export function confirmDelete(opts) {
  if (host) host(opts);
  else opts.onCancel?.();
}

// Promise form for flows that need a yes/no answer mid-way (resolves false on Cancel / Escape).
export const askConfirm = (opts) => new Promise((resolve) => confirmDelete({ ...opts, onConfirm: () => resolve(true), onCancel: () => resolve(false) }));
